<template>
  <div class="detail_carte">
    <div>
      <h1 class="title_carte">Carte en temps réel</h1>

      <div class="ligne_div row">
        <div class="col_gauche col-lg-6 col-md-12">
          <div class="description_col_gauche">
            <div class="div_arret">
              <div>
                <i class="icone_curseur fas fa-map-marker-alt fa-2x"></i><span
                class="arret">{{ passage.stopName }}</span>
              </div>
            </div>
            <hr class="separator"/>
            <div class="bloc_direction">
              <div class="div_nom_ligne">
            <span class="id_ligne"
                  :style="{ backgroundColor: '#' + passage.routeColor, color: 'white', padding: '0.5rem' }">
            {{ passage.routeId }}
            </span>
                <div class="div_destination">
                  <span class="direction">Direction</span>
                  <span class="destination">{{ passage.headsign }}</span>
                </div>
              </div>
            </div>
            <hr class="separator"/>
            <span v-if="prochainPassage.horaireArriveReel === null && prochainPassage.stopDepasse !== true"
                  class="texte_passage_prevu">
            Prochain passage prévu à
            </span><br/>

            <div class="bus_rate"
                 v-if="prochainPassage.horaireDepartReel !== null ||
                       this.departBus === true ||
                        prochainPassage.stopDepasse === true">
              <span>Désolé, le bus est passé</span><br/>
              <router-link v-if="passage.vehicule_short_id !== 'null'"
                           :to="{name:'Home', params: {stopName: passage.stopName}}">
                <b-btn class="retour_prochains_passages">
                  Retour aux prochains passages <i class="fas fa-arrow-right"></i>
                </b-btn>
              </router-link>
            </div>
            <span class="bus_arret" v-else-if="prochainPassage.horaireArriveReel !== null && this.departBus === false">
              Le  bus est à l'arrêt
            </span>
            <span class="heure_prevue" v-else-if="prochainPassage.horaireArriveEstimee !== null">
              {{ prochainPassage.horaireArriveEstimee | filtreTemps }}
            </span>
            <span class="heure_prevue" v-else-if="prochainPassage.horaireArrivePrevu !== null">
              {{ prochainPassage.horaireArrivePrevu | filtreTemps }}
            </span>
            <span class="heure_prevue" v-else>
              (Calcul en cours)
            </span>
          </div>
        </div>

        <div class="col_droite col-lg-6 col-md-12">
          <Map :busReset="busReset" :coordonnees="coordonnees" :positionArret="positionArret" :shape="shape"/>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import moment from 'moment'
  import Map from './Map'

  export default {
    name: 'Detail',
    components: {
      Map
    },
    data () {
      return {
        arret: {},
        passage: {},
        prochainPassage: {},
        positions: {},
        busReset: false,
        coordonnees: null,
        positionArret: null,

        shapeData: {},
        shape: null,

        horairePrevuafter1hour: null,
        horaireReelafterFewhours: null,

        departBus: false
      }
    },

    methods: {
      departDuBus: function () {
        if (this.prochainPassage.horaireArriveReel !== null) {
          setTimeout(function () {
            this.departBus = true
          }.bind(this), 1 * 60 * 1000)
        }
      },

      getShapes: function () {
        this.axios
          .get('/shape/' + this.$route.params.tripId)
          .then((succes) => {
            this.shapedata = succes.data
            this.shape = this.shapedata
          }, (error) => {
            console.error('ERREUR pour la recuperation de shape', error)
          })
      }
    },

    created () {
      this.axios
        .get('/stop-information/' + this.$route.params.tripId + '/' + this.$route.params.stopId, { params: { sequence: this.$route.params.numSequence } })
        .then((succes) => {
          this.passage = succes.data
          this.positionArret = this.passage
          this.getShapes()
        }, (error) => {
          console.error('ERREUR pour stop-information', error)
        })
    },

    mounted () {
      const eventSource = new EventSource(process.env.API_URL_SSE + '/temps-reel/' + this.$route.params.tripId + '/' + this.$route.params.stopId + '?sequence=' + this.$route.params.numSequence)

      eventSource.onerror = (error) => {
        console.error('Erreur sur la récupération des données en temps réel', error)
        if (event.readyState === EventSource.CLOSED) {
          console.log('on passe dans le listener')
          eventSource.close()
        }
      }

      eventSource.addEventListener('prochain_passage', event => {
        console.log('Évènement prochain_passage passé : ')
        console.log(this.prochainPassage)
        this.prochainPassage = JSON.parse(event.data)
        this.departDuBus()
      })

      eventSource.addEventListener('position', event => {
        console.log('Évènement position passé : ')
        console.log(this.positions)
        this.busReset = false
        this.positions = JSON.parse(event.data)
        this.coordonnees = this.positions
      })

      eventSource.addEventListener('reset_prochain_passage', event => {
        console.log('Évènement RESET prochain_passage effectué')
      })

      eventSource.addEventListener('reset_vehicule_position', event => {
        console.log('Évènement RESET vehicule_position effectué')
        this.busReset = true
      })
    },

    filters: {
      filtreTemps: function (horaire) {
        if (horaire) {
          return moment(String(horaire)).format('HH') + 'h' + moment(String(horaire)).format('mm')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";

.detail_carte {
  background-color: $firstcolor;
  min-height: 100vh;

  .title_carte {
    padding: 5rem;
    font-family: $linggofont;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
    color: white;
    @include media-breakpoint-down(sm) {
      padding: 1rem;
    }
  }

  .ligne_div {
    margin: 0;

    .col_gauche {
      border-radius: 25px;
      background-color: white;
      display: flex;
      text-align: center;
      margin: auto auto 1rem auto;
      @include media-breakpoint-up(md) {
        max-width: 600px;
        max-height: 500px;
        min-width: 600px;
        min-height: 500px;
      }

      @include media-breakpoint-down(sm) {
        margin-left: 1rem;
        margin-right: 1rem;
        padding: 2rem 0.2rem;
      }

      @include media-breakpoint-up(sm) {
        padding: 2rem 5rem;
      }

      @include media-breakpoint-down(lg) {
        margin-bottom: 1rem;
      }

      .separator {
        border-color: $firstcolor;
      }

      .description_col_gauche {
        margin: auto;

        .div_arret {
          font-family: $linggofont;

          .icone_curseur {
            margin-right: 10px;
            color: $secondcolor;
          }

          .arret {
            text-transform: uppercase;
            color: $secondcolor;
            font-size: 35px;
            font-weight: bold;

            @include media-breakpoint-down(sm) {
              font-size: 25px;
            }
          }
        }

        .bloc_direction {
          display: flex;
          padding: 1rem;

          .div_nom_ligne {
            margin: auto;
            display: flex;

            .id_ligne {
              font-size: 40px;
              font-weight: bold;
              height: 70px;
              margin: auto 15px auto 0;
            }

            .div_destination {
              text-align: left;
              display: grid;
              line-height: 1;
              font-family: $linggofont;

              .direction {
                text-transform: uppercase;
                font-size: 18px;
                color: $firstcolor;
                font-weight: bold;
                margin: 0;
                @include media-breakpoint-down(sm) {
                  font-size: 18px;
                  line-height: 1.7;
                }
              }

              .destination {
                font-size: 41px;
                font-weight: bold;
                color: $secondcolor;
                @include media-breakpoint-down(sm) {
                  font-size: 25px;
                }
              }
            }
          }
        }

        .texte_passage_prevu {
          margin: auto;
          font-family: $linggofont;
          color: $firstcolor;
          line-height: 1;
          @include media-breakpoint-up(lg) {
            font-size: 35px;
          }
          @include media-breakpoint-between(md, lg) {
            font-size: 33px;
          }
          @include media-breakpoint-down(sm) {
            font-size: 25px;
          }
        }
        .bus_rate {
          font-size: 35px;
          color: $secondcolor;
          .retour_prochains_passages {
            margin-top: 1rem;
            font-size: 25px;
            background-color: $firstcolor;
            border: 2px solid $firstcolor;
            border-radius: 50px;
            @include media-breakpoint-down(sm) {
              font-size: 20px;
            }
          }
          .retour_prochains_passages:hover {
            color: $firstcolor;
            background-color: white;
          }
        }
        .bus_arret {
          font-size: 40px;
          color: $secondcolor;
        }
        .heure_prevue {
          color: $secondcolor;
          font-size: 100px;
          @include media-breakpoint-down(sm) {
            font-size: 75px;
          }
        }
      }
    }

    .col_droite {
      display: contents;
      @include media-breakpoint-down(xs) {
        margin-bottom: 1rem;
      }

      @include media-breakpoint-down(md) {
        margin: auto;
        display: flex;
      }

      .bloc_erreur {
        background-color: lightgray;
        border-radius: 25px;
        padding: 2rem 5rem;
        text-align: center;
        margin: auto auto 1rem auto;
        display: flex;
        @include media-breakpoint-up(md) {
          max-width: 600px;
          max-height: 500px;
          min-width: 600px;
          min-height: 500px;
        }

        @include media-breakpoint-down(sm) {
          max-width: 300px;
          padding: 1rem;
          height: 350px;
        }

        @include media-breakpoint-down(lg) {
          margin-bottom: 1rem;
        }
        .bloc_description_erreur {
          color: $secondcolor;
          margin: auto;
          .load_spinner {
            display: flex;
            margin: auto auto 2rem auto;
            width: 5rem;
            height: 5rem;
          }
          .title_erreur {
            font-size: 50px;
            font-family: $linggofont;
            font-weight: bold;
          }
          .text_erreur {
            font-size: 35px;
            font-family: $linggofont;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DetailCarte.vue